// import Header from "./Components/Header";
// import Main from "./Components/Main";
import Taiyeheader from "./Components/Taiyeheader";
import Taiyemain from "./Components/Taiyemain";

const Layout = () => {
  return (
    <div className="h-[100svh]">
      <Taiyeheader />
      <Taiyemain />
   
    </div>
  );
};
export default Layout;
// 08160788494
